import { gql, useQuery } from "@apollo/client";

import { getSession } from "./App";
import { hasLunchAccess } from "./Lunch/access";
import { canManageUsers, hasTeamAccess, isTeamLeader } from "./permissions";

// Permissions come from the API so old sessions cannot retain revoked access.
export const CURRENT_USER = gql`
  query CurrentUser($_id: String!) {
    ViewUser(_id: $_id) {
      _id
      name
      accessLevel
      superAdmin
      roles {
        team
        roles
      }
    }
  }
`;

// Temporary allowlist, requested by Cristopher: grants VIEW access to the
// event-schedule reports screen without promoting anyone to superAdmin.
// Viewing only: publishing (Spotify audio/publish) still requires a real
// superAdmin. Mirrors SERMON_REPORTS_VIEWER_IDS in the API's
// app/services/permissions.js. Remove/revisit once a dedicated accessLevel
// exists for this.
export const SERMON_REPORTS_VIEWER_IDS = [
  "64011a709517d000250889c2", // Gabriel Catarina
  "642c56b041faec001e6dae8b", // Gabriella Alves de Araújo
  "63fa0bce5eba190025746dc1", // James Nardi Silva
  "6419da63d96e8c001eb50d94", // Alaf Borges
];

export const useCurrentUser = () => {
  const sessionUser = getSession()?.user;

  const { data, loading } = useQuery(CURRENT_USER, {
    variables: { _id: sessionUser?._id },
    skip: !sessionUser?._id,
    fetchPolicy: "cache-and-network",
  });

  const user = data?.ViewUser || null;
  const isSuperAdmin = user?.superAdmin === true;

  return {
    user,
    isSuperAdmin,
    isAdmin: user?.accessLevel === "admin" || isSuperAdmin,
    canManageConfraternity: hasTeamAccess(user, "confraternity"),
    canManageConferences: hasTeamAccess(user, "conference"),
    canManageLunch: hasLunchAccess(user),
    canManageUsers: canManageUsers(user),
    // The home churches back office: head/mentor of the team, same as the API.
    canManageHomeChurches: isTeamLeader(user, "home-churches"),
    // Read-only access to the sermon reports screen: superAdmins, plus the
    // temporary allowlist above. Same fail-closed-while-loading logic.
    canViewSermonReports:
      isSuperAdmin || SERMON_REPORTS_VIEWER_IDS.includes(user?._id),
    loading: loading && !data,
  };
};

export default useCurrentUser;
